export default {"src":"/_next/static/media/check-notifications.7a0474c1.svg","height":385,"width":482};